import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Pages saved as static HTML at build time (scripts/prerender.js) are hydrated so React takes over the
// existing markup. Everything else — and any page served a snapshot of a different route (e.g. the local
// `serve -s` fallback) — renders from scratch.
const rootEl = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
const path = window.location.pathname.replace(/\/+$/, '') || '/';

if (rootEl.dataset.prerendered === path) {
  ReactDOM.hydrateRoot(rootEl, app);
} else {
  rootEl.innerHTML = '';
  delete rootEl.dataset.prerendered;
  ReactDOM.createRoot(rootEl).render(app);
}
window.__rbReady = true;
